import Loader from "components/loader/Loader";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  TabPane,
  ListGroup,
  ListGroupItem,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
const ViewTicket = () => {
  const navigate = useNavigate();
  const [addsLoadig, setAddsLoadig] = useState();
  return (
    <Container className="pt-7">
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardBody>
              <Card className="mb-3 w-100" style={{ borderRadius: ".5rem" }}>
                <Row className="g-0">
                  <Col md="12">
                    <CardBody className="p-4">
                      <Row className="pt-1">
                        <Col size="12" className="mb-3">
                          <div className="top-card-div">
                            <div
                              style={{
                                lineHeight: "13px",
                                paddingTop: "15px",
                              }}
                            >
                              <p style={{ color: "black", fontWeight: "bold" }}>
                                {" "}
                                <span
                                  style={{
                                    color: "lightgray",
                                    fontWeight: "bold",
                                    width:"50px"
                                  }}
                                >
                                  Subject{" "}
                                </span>
                                {/* - {employeeDetails?.designation} */} -{" "}
                                {/* {dataList?.first_name}{" "} */}
                              </p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-4" />
                      <Row className="pt-1">
                        <Col size="12" className="mb-3">
                          <div className="top-card-div">
                            <p
                              className="card-text"
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              <span
                                style={{
                                  color: "lightgray",
                                  fontWeight: "bold",
                                }}
                              >
                                Message -
                              </span>{" "}
                              {/* {dataList?.grade_level} */}
                              <br />{" "}
                              {/* {employeeDetails?.parent_department_name}{" "} */}
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-4" />
                      <Row className="pt-1">
                        <Col size="12" className="mb-3">
                          <div className="top-card-div">
                            <p
                              className="card-text"
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              <span
                                style={{
                                  color: "lightgray",
                                  fontWeight: "bold",
                                }}
                              >
                                Priority -
                              </span>{" "}
                              {/* {dataList?.school_name} */}
                              <br />{" "}
                              {/* {employeeDetails?.parent_department_name}{" "} */}
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-0 mb-4" />
                      <Row className="pt-1">
                        {/* <Col size="12" className="mb-3">
                      <div className="top-card-div">
                        <p className="card-text" style={{ color: "black", fontWeight: "bold" }}>
                          <span
                            style={{ color: "lightgray", fontWeight: "bold" }}
                          >
                            About-
                          </span>{" "}
                          {dataList?.user_bio}
                          <br />{" "}
                          {/* {employeeDetails?.parent_department_name}{" "} */}
                        {/* </p>
                      </div>
                    </Col> */}

                        <Col size="12" className="mb-3">
                          <div className="top-card-div">
                            <p
                              className="card-text"
                              style={{
                                color: "black",
                                fontWeight: "bold",
                                textAlign: "justify",
                              }}
                            >
                              <span
                                style={{
                                  color: "lightgray",
                                  fontWeight: "bold",
                                }}
                              >
                                Image-
                              </span>{" "}
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Col>
                </Row>
              </Card>
              <Card className="mb-3 w-100" style={{ borderRadius: ".5rem" }}>
                <CardBody className="p-4">
                  <Row className="g-0">
                    <Col md="12">
                      <FormGroup>
                        <Label for="exampleEmail">Status</Label>
                        <Input id="forType" name="forType" type="select">
                          <option value="driver">Select Status </option>
                          <option value="tutor">Pending</option>
                          <option value="student">Done</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="exampleEmail">Reply</Label>
                        <Input
                          id="name"
                          name="name"
                          type="textarea"
                          placeholder="Enter Description"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      color="secondary"
                      onClick={() => {
                        navigate("/admin/supportticket");
                      }}
                    >
                      Cancel
                    </Button>

                    {addsLoadig ? (
                      <Loader color={"blue"} />
                    ) : (
                      <Button
                        color="primary"
                        type="submit"
                        style={{
                          float: "right",
                          marginLeft: "5%",
                          backgroundColor: "#080278",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Save
                      </Button>
                    )}
                  </div>
                </CardBody>
              </Card>
            </CardBody>
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default ViewTicket;
